var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Pricing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/maps/local_atm_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 17C20 17.55 19.55 18 19 18H5C4.45 18 4 17.55 4 17V7C4 6.45 4.45 6 5 6H19C19.55 6 20 6.45 20 7V17ZM12 8.99999C12 9.54999 11.55 9.99999 11 9.99999H8V11H11C11.55 11 12 11.45 12 12V15C12 15.55 11.55 16 11 16H10C10 16.55 9.55 17 9 17C8.45 17 8 16.55 8 16H7C6.45 16 6 15.55 6 15C6 14.45 6.45 14 7 14H10V13H7C6.45 13 6 12.55 6 12V8.99999C6 8.44999 6.45 7.99999 7 7.99999H8V7.98999C8 7.43999 8.45 6.98999 9 6.98999C9.55 6.98999 10 7.43999 10 7.98999V7.99999H11C11.55 7.99999 12 8.44999 12 8.99999Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon/av/play_arrow_24px",
    d: "M14.743 10L17.257 10C17.4487 10 17.5652 9.82849 17.4608 9.6964L16.2038 8.09167C16.1092 7.96944 15.8908 7.96944 15.7937 8.09167L14.5392 9.6964C14.4348 9.82849 14.5513 10 14.743 10Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon/av/play_arrow_24px_2",
    d: "M17.257 14L14.743 14C14.5513 14 14.4348 14.1715 14.5392 14.3036L15.7962 15.9083C15.8908 16.0306 16.1092 16.0306 16.2063 15.9083L17.4608 14.3036C17.5652 14.1715 17.4487 14 17.257 14Z",
    fill: "#4E5968"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/Pricing.ef6f9e9ae4bf4211aba9fc3e20364339.svg";
export { ForwardRef as ReactComponent };